import { BetslipPick } from '../../../core/picks/betslip-pick';
import { PickId } from '../../../core/picks/pick-id';

export function removeOrderedTypePicks(pickIds: PickId[], picksState: Record<string, { order: number }>): void {
    const removedOrders = pickIds.map((pickId) => picksState[pickId.toString()]?.order);

    removeTypePicks(pickIds, picksState);

    //After removing picks we need to reorder the remaining picks
    Object.values(picksState).forEach((pick) => {
        const orderDifference = getOrderDifference(pick.order, removedOrders);

        if (orderDifference <= 0) {
            return;
        }

        pick.order -= orderDifference;
    });
}

export function removeTypePicks(pickIds: PickId[], picksState: Record<string, {}>): void {
    pickIds.forEach((pick) => {
        delete picksState[pick.id.toString()];
    });
}

//check the pick order against the order of the removed picks
//returns the sum which we need to deduct from current pick order
export function getOrderDifference(currentOrder: number, removed: number[]): number {
    return removed.filter((num) => num < currentOrder).length;
}

export function addOrderedPicks<T extends { order: number }>(picks: BetslipPick[], picksState: Record<string, T>, defaultPickFactory: () => T): void {
    const existingLength = Object.keys(picksState).length;

    picks
        .map((pick) => pick.id.toString())
        .filter((pickId) => !picksState[pickId])
        .forEach((pickId, i) => {
            picksState[pickId] = {
                ...defaultPickFactory(),
                order: existingLength + i,
            };
        });
}
